module.exports = __webpack_public_path__ + "img/area_cakupan.b6557f50.svg";